import { queryOptions } from '@tanstack/react-query';

import {
    FEES_SETTINGS_TYPE,
    SUPERBILL_SETTINGS_TYPE,
} from '../model/client-billing-settings.schemas';
import type { ClientBillingSettingsType } from '../model/client-billing-settings.types';
import { clientBillingSettingsApi } from './client-billing-settings.api';

export const queryKeys = {
    all: ['client-billing-settings'] as const,
    byType: (type: ClientBillingSettingsType) => [...queryKeys.all, type] as const,
};

export function clientBillingSettingsByTypeOptions<T extends ClientBillingSettingsType>(type: T) {
    return queryOptions({
        queryKey: queryKeys.byType(type),
        queryFn: ({ signal }) => clientBillingSettingsApi.getByType(type, signal),
    });
}

export function superbillSettingsOptions() {
    return clientBillingSettingsByTypeOptions(SUPERBILL_SETTINGS_TYPE);
}

export function feesSettingsOptions() {
    return clientBillingSettingsByTypeOptions(FEES_SETTINGS_TYPE);
}
